import React from "react";

import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import IconButton from "material-ui/IconButton";
//import LanguageIcon from "material-ui-icons/Language";
import MenuIcon from "material-ui-icons/Menu";
import SettingsIcon from "material-ui-icons/Settings";
import Menu, { MenuItem } from "material-ui/Menu";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { openDrawer } from "../../modules/navigation";
import { changeValuesTempReport } from "../../modules/temp";
import {
  setLanguageES,
  setLanguageEN,
  changeTemperatureUnit
} from "../../modules/internationalization";
import UserApi from "../../api/userApi";
import {
  changeTempReportToCelsius,
  changeTempReportToFahrenheit
} from "./../../utilities/temp";
import { DOMAIN } from "../../utilities/consts";

import "./MenuAppBar.css";

class MenuAppBar extends React.Component {
  state = {
    anchorEl: null
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLanguageChange = () => {
    const { lang, setLanguageES, setLanguageEN } = this.props;
    switch (lang._code) {
      case "en":
        setLanguageES();
        break;
      case "es":
      default:
        setLanguageEN();
        break;
    }
    this.handleClose();
  };

  toZeekGPS = () => {
    window.open(`${DOMAIN}mapa.aspx`, "_BLANK");
  };

  logOut = () => {
    UserApi.logout()
      .then(r => {
        window.open(`${DOMAIN}/mapa.aspx`, "_SELF");
      })
      .catch(r => {
        window.open(`${DOMAIN}/mapa.aspx`, "_SELF");
      });
  };

  changeTemperatureUnit = () => {
    const { tempData, tempUnit } = this.props;
    this.props.changeTemperatureUnit(tempUnit === "F" ? "C" : "F");
    if (tempData.UnidadTemperatura === 0 && tempUnit === "C") {
      let data = changeTempReportToFahrenheit(tempData);
      this.props.changeValuesTempReport(data);
    } else if (tempData.UnidadTemperatura === 1 && tempUnit === "F") {
      let data = changeTempReportToCelsius(tempData);
      this.props.changeValuesTempReport(data);
    }
    this.handleClose();
  };

  render() {
    const { anchorEl } = this.state;
    // const { auth } = this.state;
    const open = Boolean(anchorEl);

    const { lang, title } = this.props;

    return (
      <div className="menu-app-bar">
        <AppBar position="static" elevation={3}>
          <Toolbar>
            <IconButton
              className="menu-button"
              color="inherit"
              aria-label="Menu"
              onClick={this.props.openDrawer}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="title" color="inherit" className="flex">
              {title}
            </Typography>
            {
              <div>
                <IconButton
                  aria-owns={open ? "menu-appbar" : null}
                  aria-haspopup="true"
                  onClick={this.handleMenu}
                  color="inherit"
                >
                  <SettingsIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right"
                  }}
                  open={open}
                  onClose={this.handleClose}
                >
                  <MenuItem onClick={this.handleLanguageChange}>
                    {lang.CambiarIdioma}
                  </MenuItem>
                  {this.props.permissions.ConsultaTemp && (
                    <MenuItem onClick={this.changeTemperatureUnit}>
                      {lang.CambiarUnidadTemperaturaA} °
                      {this.props.tempUnit === "F" ? "C" : "F"}
                    </MenuItem>
                  )}
                  <MenuItem onClick={this.toZeekGPS}>Zeek GPS</MenuItem>
                  <MenuItem onClick={this.logOut}>{lang.LogOut}</MenuItem>
                  {/* <MenuItem onClick={this.handleClose}>My account</MenuItem> */}
                </Menu>
              </div>
            }
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openDrawer,
      setLanguageES,
      setLanguageEN,
      changeTemperatureUnit,
      changeValuesTempReport
    },
    dispatch
  );

const mapStateToProps = state => ({
  lang: state.internationalization.lang,
  title: state.navigation.title,
  tempUnit: state.internationalization.temperatureUnit,
  permissions: state.permissions.data,
  tempData: state.temp.data
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuAppBar);



// WEBPACK FOOTER //
// ./src/containers/MenuAppBar/MenuAppBar.js